import { render, staticRenderFns } from "./TableOpenToBuy.vue?vue&type=template&id=cdcbd9a0&scoped=true"
import script from "./TableOpenToBuy.vue?vue&type=script&lang=js"
export * from "./TableOpenToBuy.vue?vue&type=script&lang=js"
import style0 from "./TableOpenToBuy.vue?vue&type=style&index=0&id=cdcbd9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._pvxtve42dn25yfzifbo3bypexu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcbd9a0",
  null
  
)

export default component.exports